// Angular
import {Injectable} from '@angular/core';
// RxJS
import {BehaviorSubject} from 'rxjs';
// Services
import {MenuConfigService} from './menu-config.service';
import {HeaderMenuModel} from '../../../_config/menu.config';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Injectable({providedIn: 'root'})
export class MenuHorizontalService {
  menuList$: BehaviorSubject<HeaderMenuModel[]> = new BehaviorSubject<HeaderMenuModel[]>([]);

  constructor(private menuConfigService: MenuConfigService) {
    this.loadMenu();
  }

  loadMenu() {
    this.menuConfigService.onConfigUpdated$.subscribe(
      (datas: HeaderMenuModel[]) => {
        if (isNotNullOrUndefined(datas)) {
          this.menuList$.next(datas);
        }
      }
    );
  }
}
